import type { HTMLAttributes, FC, Ref } from "react";
import { motion, type MotionProps } from "motion/react";
import type { RecipeVariants } from "@vanilla-extract/recipes";
import { mergeClasses } from "@huub-web/utils";

import { rulerStyle } from "./Ruler.css";

export type RulerProps = HTMLAttributes<HTMLHRElement> &
  RecipeVariants<typeof rulerStyle> & {
    className?: string;
    variants?: MotionProps["variants"];
    /**
     * Ref forwarded to the root element
     */
    ref?: Ref<HTMLHRElement>;
  };

/**
 * A simple ruler component that can be used to separate content.
 */
export const Ruler: FC<RulerProps> = ({
  variant,
  direction,
  className,
  ref,
  ...props
}) => (
  <motion.hr
    ref={ref}
    className={mergeClasses(rulerStyle({ variant, direction }), className)}
    aria-hidden="true"
    {...(props as MotionProps)}
  />
);
